module.exports = __webpack_public_path__ + "static/hyperv_37.39f68d8b.jpg";